import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmReportsCustomTimeScaleRoute: InvariantJiraRoute = {
	name: 'csm-reports-custom-time-scale',
	path: '/jira/customer-service-management/projects/:projectKey/reports/custom/:reportId/timescale/:timescaleId',
};
